/* Base translations · Disclosure (disc) labels — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): disc. */
export const I18N_BASE_DISCLOSURE = {
  en: {
    disc: {
      title: "Discrepancy Report",
      subtitle: "Cross-check findings across GL and supporting documents · ISA 500 · ISA 230 · ISA 450",
      run: "Run detection",
      type: "Type",
      risk: "Risk",
      description: "Description",
      linkedDocs: "Linked docs",
      voucherRef: "Vouching item",
      docRefs: "Documents",
      explain: "Explain",
      filterAll: "All risks",
      exportXlsx: "Export XLSX",
      noFindings: "No findings. Run detection to see results.",
      attach: "Attach",
      attachLabel: "Attach management response, follow-up evidence or exceptions",
      a3: {
        missingSupportText: "Evidence gap: no supporting document is attached for this item. Attach the document, or record why it is not available and the alternative procedure performed. Until then this item is not supported by audit evidence.",
        reasonNotAvailable: "Reason support is not available",
        alternativeProcedure: "Alternative procedure performed",
        result: "Result",
        resultChoose: "Choose result…",
        resultNoDiff: "No difference",
        resultDiff: "Difference found",
        diffAmount: "Difference amount",
        diffType: "Type",
        mtypeFactual: "Factual",
        mtypeJudgmental: "Judgmental",
        mtypeProjected: "Projected",
        resolveGate: "Fill Reason not available AND Alternative procedure before selecting a Result.",
        sendBtn: "Send to misstatements",
        sendGate: "Enabled only when Result = Difference found.",
        sentIndicator: "Sent to misstatements", resendBtn: "Send again (refresh amount)",
        sentToast: "One Unresolved record was added to Misstatements Summary.",
      },
      typeLabels: {
        gl_vs_invoice_amount: "GL vs Invoice amount",
        invoice_vs_po_amount: "Invoice vs PO amount",
        grn_invoice_qty_mismatch: "GRN vs Invoice quantity",
        missing_signature: "Missing signature",
        vat_calculation: "VAT calculation",
        vat_amount_mismatch: "VAT amount mismatch",
        invoice_total_check: "Invoice total check",
        duplicate_invoice: "Duplicate invoice",
        duplicate_invoice_near: "Near-duplicate invoice",
        contract_expired: "Contract expired",
        contract_not_started: "Contract not started",
        vendor_name_mismatch: "Vendor name mismatch",
        party_mismatch: "Party name mismatch",
        amount_mismatch: "Amount mismatch",
        po_number_mismatch: "PO number mismatch",
        grn_number_mismatch: "GRN number mismatch",
        missing_date: "Missing date",
        date_mismatch: "Date mismatch",
        missing_document: "Missing supporting document",
      },
    },
  },
  ar: {
    disc: {
      title: "تقرير الفروقات",
      subtitle: "فحص الفروقات بين الأستاذ العام والمستندات · معيار 500 · معيار 230 · معيار 450",
      run: "تشغيل الكشف",
      type: "النوع",
      risk: "الخطر",
      description: "الوصف",
      linkedDocs: "المستندات المرتبطة",
      voucherRef: "عنصر التدقيق",
      docRefs: "المستندات",
      explain: "شرح",
      filterAll: "كل المخاطر",
      exportXlsx: "تصدير XLSX",
      noFindings: "لا توجد نتائج. شغّل الكشف لعرض النتائج.",
      attach: "إرفاق",
      attachLabel: "أرفق رد الإدارة أو أدلة المتابعة أو الاستثناءات",
      a3: {
        missingSupportText: "فجوة في الدليل: لا يوجد مستند داعم مرفق بهذا البند. أرفق المستند، أو سجّل سبب عدم توفره والإجراء البديل الذي نُفِّذ. إلى أن يُستكمل ذلك، لا يوجد دليل تدقيق يدعم هذا البند.",
        reasonNotAvailable: "سبب عدم توفر الدليل",
        alternativeProcedure: "الإجراء البديل المُنفَّذ",
        result: "النتيجة",
        resultChoose: "اختر النتيجة…",
        resultNoDiff: "لا يوجد فرق",
        resultDiff: "تم اكتشاف فرق",
        diffAmount: "قيمة الفرق",
        diffType: "النوع",
        mtypeFactual: "فعلي",
        mtypeJudgmental: "تقديري",
        mtypeProjected: "مُسقَط",
        resolveGate: "املأ سبب عدم توفر الدليل والإجراء البديل قبل اختيار النتيجة.",
        sendBtn: "إرسال إلى ملخص التحريفات",
        sendGate: "مُتاح فقط عندما تكون النتيجة = تم اكتشاف فرق.",
        sentIndicator: "تم الإرسال إلى ملخص التحريفات", resendBtn: "إرسال مجددًا (تحديث المبلغ)",
        sentToast: "تمت إضافة سجل واحد بحالة \"غير محلول\" إلى ملخص التحريفات.",
      },
      typeLabels: {
        gl_vs_invoice_amount: "الأستاذ مقابل الفاتورة",
        invoice_vs_po_amount: "الفاتورة مقابل أمر الشراء",
        grn_invoice_qty_mismatch: "كمية إشعار الاستلام مقابل الفاتورة",
        missing_signature: "توقيع مفقود",
        vat_calculation: "حساب ضريبة القيمة المضافة",
        vat_amount_mismatch: "اختلاف مبلغ ضريبة القيمة المضافة",
        invoice_total_check: "التحقق من إجمالي الفاتورة",
        duplicate_invoice: "فاتورة مكررة",
        duplicate_invoice_near: "فاتورة شبه مكررة",
        contract_expired: "عقد منتهي",
        contract_not_started: "العقد لم يبدأ بعد",
        vendor_name_mismatch: "اختلاف اسم المورد",
        party_mismatch: "اختلاف اسم الطرف",
        amount_mismatch: "اختلاف في المبلغ",
        po_number_mismatch: "اختلاف رقم أمر الشراء",
        grn_number_mismatch: "اختلاف رقم إشعار الاستلام",
        missing_date: "تاريخ مفقود",
        date_mismatch: "اختلاف في التاريخ",
        missing_document: "مستند داعم مفقود",
      },
    },
  },
};

export default I18N_BASE_DISCLOSURE;
